<template>
  <div class="addMessageType">
    <!--新增-->
    <el-dialog
      :title="$t('transportDeliveryOrder.sendMessage.warehouseTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="866px"
    >
      <el-form
        label-width="auto"
        :model="formData"
        ref="formData"
        :rules="rules"
        :label-position="'right'"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item :label="this.$t('transportDeliveryOrder.sendMessage.companySaveName')">
              <el-input v-model="formData.warehouseName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="sendPhone"
              :label="this.$t('transportDeliveryOrder.sendMessage.contactPhone')"
            >
              <el-input
                v-model="formData.sendPhone"
                :placeholder="this.$t('transportDeliveryOrder.sendMessage.contactPhonePlaceholder')"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              prop="sendMsg"
              :label="this.$t('transportDeliveryOrder.sendMessage.content')"
            >
              <el-input
                v-model="formData.sendMsg"
                :placeholder="this.$t('transportDeliveryOrder.sendMessage.contentPlaceholder')"
                type="textarea"
                :rows="3"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="load" @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
        <el-button :loading="load" type="primary" @click="sendMessage">{{
          $t('dialog.send')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/logisticsCenter/transportDeliveryOrder.js';
  import masterObj from '@/common/js/masterObj';
  // import SearchModal from '@/components/SearchModal';
  import formRules from '../rules/rules';
  import { mapState } from 'vuex';

  export default {
    name: 'detailMessageTask',
    components: {
      // SearchModal,
    },
    data() {
      return {
        load: false,
        dialogAdd: false,
        formData: {
          warehouseName: '',
          sendMsg: '',
          sendPhone: '',
        },
        partner: masterObj.customer,
        warehouse: masterObj.warehouse,
        rules: formRules.sendMessage,
        person: masterObj.person,
        first: '',
        center: '',
        customerName: '',
        deliveryNote: '',
        outboundNo: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    methods: {
      openDialog(flag, data) {
        if (this.$refs['formData']) {
          this.$refs['formData'].resetFields();
        }
        this.dialogAdd = flag;
        this.formData.warehouseName = data.outboundStorageName;
        this.formData.sendPhone = data.storageContactPhone;
        this.outboundNo = data.outboundNo;
        this.getDetail(data.outboundNo);
      },
      //获取详细信息
      getDetail(outboundNo) {
        this.$axios.get(API.DETAIL_TRANSPORTDELIVERYORDER_API + outboundNo).then((res) => {
          if (0 == res.data.code) {
            let formData = res.data.data;
            this.customerName = formData.customerName;
            this.deliveryNote = formData.deliveryNote;
            let transport = res.data.data.deliveryTransportList[0];
            let product = res.data.data.outboundDetailList[0];
            let businessOrderQuantity =
              product.businessOrderQuantity || product.businessOrderPackage;
            let productInfo =
              product.productName + ' ' + businessOrderQuantity + product.productUnitName;
            let nameVoyageLicense = transport
              ? '车辆信息：' + transport.nameVoyageLicense + '，'
              : '';
            let freightInformation = transport
              ? transport.freightInformation
                ? transport.freightInformation
                : '备注'
              : '备注';
            // let customerName = this.customerName ? this.customerName : '';
            this.first =
              '【' +
              formData.storageCompanyName +
              '】' +
              '【' +
              outboundNo +
              '】' +
              productInfo +
              '等。';
            // this.center = nameVoyageLicense +'【'+ freightInformation+'】，【'+ this.deliveryNote +'】，请知晓。【'+ customerName +'】'
            this.center =
              nameVoyageLicense +
              '【' +
              freightInformation +
              '】，请知晓。【' +
              this.userInfo.userInfo.companyName +
              '】';
            this.formData.sendMsg = this.first + this.center;
          }
        });
      },
      //选择联系人
      setContactPerson(val, row) {
        if (row.length > 0) {
          this.formData.contactPerson = row[0].returnSalesmanName;
          this.formData.contactPersonName = row[0].returnSalesmanName;
          this.formData.sendMsg =
            '【' + this.formData.customerName + '】' + this.first + this.center + val;
        }
      },
      //选择客户
      setCustomer(val, row) {
        if (row.length > 0) {
          this.formData.customerNo = row[0].partnerCode;
          this.formData.customerName = row[0].partnerZhName;
          this.formData.sendMsg =
            '【' + this.formData.customerName + '】' + this.first + this.center + val;
        }
      },
      //发送短信
      sendMessage() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.load = true;
            let params = {
              outboundNo: this.outboundNo,
              sendPhone: this.formData.sendPhone,
              sendMsg: this.formData.sendMsg,
            };
            this.$axios.post(API.SENDMESSAGE_TRANSPORTDELIVERYORDER_API, params).then((res) => {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.load = false;
              if (0 == res.data.code) {
                this.dialogAdd = false;
              }
            });
          }
        });
      },
    },
  };
</script>
